import { takeLatest, call, put, delay } from 'redux-saga/effects';
import Type from '../../actions';
import * as api from '../../../server';
import { message } from 'antd';

message.config({
  duration: 2,
  maxCount: 1,
});

// 上传签名
//TODO 查看路由
export function* postSignature(action) {
  try {
    const name = Date.now()
    const res = yield call(api.getSignatureID, `${name}.png`);
    if (res.resID) {
      let formData = new FormData();
      const file = dataURLtoFile(action.src, `${name}.png`)
      formData.append('file', file)
      const signature = yield call(api.postSignature, formData, res.resID);
      if (signature.status === 0) {
        message.success('签名提交成功')
      }
    }

  } catch (error) {
    message.error(error)
  }
}

function dataURItoBlob(dataURI, name) {
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  let ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  let result = new Blob([ia], { type: mimeString });
  result = Object.assign(result, {
    // 这里一定要处理一下 URL.createObjectURL
    preview: URL.createObjectURL(result),
    name: name
  });
  return result
}

function dataURLtoFile(dataUrl, filename) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const str = atob(arr[1]);
  let n = str.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = str.charCodeAt(n);
  }
  //转换成file对象
  return new File([u8arr], filename, { type: mime });
}


export function* postSignatureRequest() {
  yield takeLatest(Type.POST_CANVAS, postSignature)
}
